define(['angular'], function(angular) {


    function ReportRoutingService($location, $window, $rootScope, filesService, editionService) {
        var self = this;

        self.openReportPDF = function (reportName, order, type) {
            switch (reportName) {
                case 'SEPA':
                    $window.open(editionService.url + 'edition/sepa/' + type + '/' + order.client.id + '/' + order.id, '_blank');
                    break;
                case 'DELOITTE':
                    $window.open(
                        editionService.url + 'edition/client/' + order.client.id + '/BDC_DeloitteCGV',
                        '_blank'
                    );
                    $window.open(
                        editionService.url + 'edition/client/' + order.client.id + '/BDC_DeloitteDemandeSubventionInfo',
                        '_blank'
                    );
                    break;
                case 'PV_INSTALLATION':
                    $window.open(editionService.url + 'edition/order/' + order.id + '/BDC_PVInstallation', '_blank');
                    break;
                case 'PROLASER' :
                    $window.open(
                        editionService.url + 'edition/order/' + order.id + '/BDC_Prolaser',
                        '_blank'
                    );
            }
        };

        /**
         * Open a report for the corresponding order
         * @param  {String} reportName
         * @param  {Object / Array} order
         * @param option
         * @param offerType
         */
        self.openReport = function openReport(reportName, order, option, offerType) {
            if (!Array.isArray(order)) {
                $rootScope.order = order;
            }
            else {
                $rootScope.orders = order;
            }

            switch (reportName) {
                case 'TABACPRESSE':
                    $location.path('/reports/bdc-tabac-presse');
                    break;
                case 'LADDITION':
                    $location.path('/reports/bdc-laddition');
                    break;
                case 'TPE':
                    $location.path('/reports/bdc-tpe');
                    break;
                case 'SCANUP':
                    $location.path('/reports/bdc-scanup');
                    break;
                case 'FLASHUP':
                    $location.path('/reports/bdc-flashup');
                    break;
                case 'PROFORMA':
                    $location.path('/reports/proforma');
                    break;
                case 'PROFORMANAP':
                    $location.path('/reports/proforma-nap');
                    break;
                case 'SEPA':
                    $location.path('/reports/sepa/' + option);
                    break;
                case 'MUDETAF':
                    $location.path('/reports/mudetaf');
                    break;
                case 'NAP':
                    $location.path('/reports/bdc-nap');
                    break;
                case 'NAPOLD':
                    $location.path('/reports/bdc-nap-old');
                    break;
                case 'NAPOPTIONS':
                    $location.path('/reports/bdc-nap-options');
                    break;
                case 'NAPSERVICES':
                    $location.path('/reports/bdc-nap-services');
                    break;
                case 'SEPAEASYFI':
                    $location.path('/reports/sepa-easyfi');
                    break;
                case 'SEPASEDDIF':
                    $location.path('/reports/sepa-seddif');
                    break;
                case 'OFFREFI':
                    $location.path('/reports/offre-fi');
                    break;
                case 'CHECKLIST':
                    $location.path('/reports/checklist');
                    break;
                case 'SCANNETTE':
                    $location.path('/reports/scannette');
                    break;
                case 'JDS':
                    $rootScope.jdsOrderType = option;
                    $rootScope.jdsOfferType = offerType === undefined ? null : offerType;
                    $location.path('/reports/jds');
                    break;
                case 'EXPORTLADDITION':
                    $location.path('/reports/export-laddition');
                    break;
                case 'EXPORTWEBTILL':
                    $location.path('/reports/export-webtill');
                    break;
                case 'SIMULATION':
                    $location.path('/reports/simulation');
                    break;
                case 'RESILIATION':
                    $location.path('/reports/resiliation/');
                    break;
                case 'CHECKLIST_MATERIEL':
                    $location.path('/reports/checklist-materiel');
                    break;
                case 'COURRIER_BIENVENUE':
                    $window.open(filesService.ROOT_PATH + 'Courrier de bienvenue.pdf', '_blank');
                    break;
                case 'FLEURISTE':
                    $location.path('/reports/bdc-fleuriste/' + order.offer.code);
                    break;
                case 'ACCORD_SOLDE_CONTRAT_EN_COURS':
                    $window.open(
                        filesService.ROOT_PATH + 'Accord_relatif_au_solde_d_un_contrat_de_location_20190910.pdf',
                        '_blank'
                    );
                    break;
                case 'SOUSCRIPTION OFFRE CASH-IN':
                    $window.open(filesService.ROOT_PATH + 'SOUSCRIPTION OFFRE CASH-IN.pdf', '_blank');
                    break;
                case 'BUNDLE_ELECTRONIC_SIGNATURE':
                    $location.path('/reports/bundle-electronic-signature');
                    break;
                case 'BUNDLE_NAP_ELECTRONIC_SIGNATURE':
                    $location.path('/reports/bundle-nap-electronic-signature');
                    break;
                case 'FEL_DEMANDE':
                    $window.open(filesService.ROOT_PATH + 'Guide_de_remplissage_CONTRAT_FEL_A_LA_DEMANDE.pdf', '_blank');
                    break;
                case 'FEL_COMPLET':
                    $window.open(filesService.ROOT_PATH + 'Guide_de_remplissage_CONTRAT_FEL_ABONNEMENT_EXCLUSIF_FINAL.pdf', '_blank');
                    break;
            }
        };

        /**
         * Go back to the order form
         */
        self.goToOrderForm = function goToOrderForm() {
            $location.path('/bdc/order');
        };

        self.goToESign = (order) => {
            $rootScope.order = order;
            let id = order.contract.contractType.code === 'ACHAT' ? order.id : order.idElectronicSignature;
            $location.path('/reports/esign/'+id);
        }

        self.goToCpi = function goToCpi(order) {
            $rootScope.order = order;
            $rootScope.cpi = order.cpi;
            $location.path('/bdc/cpi');
        };

        self.goBack = function goBack() {
            $window.history.back();
        };

        /**
         * Print the page
         */
        self.print = function print() {
            window.print();
        };

        return self;
    }

    ReportRoutingService.$inject = ['$location', '$window', '$rootScope', 'filesService', 'editionService'];

    angular.module('app.bdc.list.reportRoutingService', []).factory('reportRoutingService', ReportRoutingService);
});
